/** List agent conversations */
export const agentConversationListSpec = {
    uri: '/agent/conversation/list',
    method: 'POST',
    adminOnly: true,
};
